// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.scl--ursb-out-sty-const.active{
    opacity: 1;
    position: fixed;
    inset: 0;
    background: rgba(0,0,0,0.35);
    transition: opacity 180ms ease;
    z-index: 1001;
}

.scl--ursb-aside-const-sty-box {
  position: fixed;
  top: 0;
  right: 0;
  height: 100vh;
  max-width: 92vw;
  background: #fff;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.18);
  transform: translateX(110%);
  transition: transform 220ms ease;
  z-index: 1002;
  display: flex;
  flex-direction: column;
  
}

.scl--ursb-aside-const-sty-box.active {
  transform: translateX(0);
}

.scl--ursb-head-box-const-styl{
    width: 100%;
    height: 65px;
    background-color: rgba(248, 248, 248, 1);
    display: flex;
    padding-left: 24px;
    padding-right: 24px;
    justify-content: space-between;
    align-items: center;
}

.scl--ursb-head-box-const-styl h6{
    margin: 0;
    padding: 0;
    font-size: 30px;
    font-weight: 600;
    font-family: var( --font-family-inter);
    color: var(--typography-text-body-primary);
    display: flex;
    align-items: center;
}

.scl--ursb-head-box-const-styl button{
    border: none;
    background-color: transparent;
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/context-controller-mod/context-serv/global-provider/right-sidebar-provider/css/right-sidebar-context.css"],"names":[],"mappings":";AACA;IACI,UAAU;IACV,eAAe;IACf,QAAQ;IACR,4BAA4B;IAC5B,8BAA8B;IAC9B,aAAa;AACjB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,0CAA0C;EAC1C,2BAA2B;EAC3B,gCAAgC;EAChC,aAAa;EACb,aAAa;EACb,sBAAsB;;AAExB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,wCAAwC;IACxC,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,UAAU;IACV,eAAe;IACf,gBAAgB;IAChB,sCAAsC;IACtC,0CAA0C;IAC1C,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,6BAA6B;IAC7B,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,eAAe;AACnB","sourcesContent":["\n.scl--ursb-out-sty-const.active{\n    opacity: 1;\n    position: fixed;\n    inset: 0;\n    background: rgba(0,0,0,0.35);\n    transition: opacity 180ms ease;\n    z-index: 1001;\n}\n\n.scl--ursb-aside-const-sty-box {\n  position: fixed;\n  top: 0;\n  right: 0;\n  height: 100vh;\n  max-width: 92vw;\n  background: #fff;\n  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.18);\n  transform: translateX(110%);\n  transition: transform 220ms ease;\n  z-index: 1002;\n  display: flex;\n  flex-direction: column;\n  \n}\n\n.scl--ursb-aside-const-sty-box.active {\n  transform: translateX(0);\n}\n\n.scl--ursb-head-box-const-styl{\n    width: 100%;\n    height: 65px;\n    background-color: rgba(248, 248, 248, 1);\n    display: flex;\n    padding-left: 24px;\n    padding-right: 24px;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.scl--ursb-head-box-const-styl h6{\n    margin: 0;\n    padding: 0;\n    font-size: 30px;\n    font-weight: 600;\n    font-family: var( --font-family-inter);\n    color: var(--typography-text-body-primary);\n    display: flex;\n    align-items: center;\n}\n\n.scl--ursb-head-box-const-styl button{\n    border: none;\n    background-color: transparent;\n    width: 30px;\n    height: 30px;\n    display: flex;\n    align-items: center;\n    cursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
